import { InfoButton, Para, Stack } from '@drycut/ui-components';

import type { CheckoutStepProps } from '../CheckoutStep';

type Props = {
  manual: boolean;
};

export function CustomerDetailsHeading({ manual }: Props): CheckoutStepProps['title'] {
  if (!manual) {
    return 'Deine Details';
  }

  return (
    <Stack direction="row">
      <Para as="span" weight="medium">
        Deine Details
      </Para>

      <InfoButton
        title="Deine Details"
        text="Zur Bestätigung senden wir Dir eine SMS mit Deiner persönlichen Wartezeit."
        className="z-20"
      />
    </Stack>
  );
}
